module.exports = __webpack_public_path__ + "media/src/img/soh-logo-c9ee90a917900fc1def589010ddffbcd.png";